<form nz-row novalidate
  #formPhoneNumber="ngForm"
  class="card-container-shadow padding-md"
  [ngClass]="{'card-container-shadow': !removeClassCardContainerShadow}">
  <div nz-col nzSpan="24">

    <!--Header-->
    <ng-container class="mb-sm">
      <div nz-row nzJustify="space-between" nzAlign="middle">
        <div nz-col class="text-subtitle-bold-upper" *ngIf="!withoutHeader">
          <p>Teléfonos</p>
        </div>
        <div nz-col *ngIf="!limit || this.phones.length <limit">
          <button nz-button [disabled]="disabled" class="btn-default
            align-self-end" type="button" nzType="default"
            (click)="onAddPhoneNumber()">
            <i nz-icon nzType="phone" nzTheme="outline"></i>
            Nuevo
          </button>
        </div>
      </div>
      <p class="text-info mb-xs" *ngIf="this.phones?.length> 0 && description">{{ description }}</p>
    </ng-container>
    <!-- /Header -->

    <!--Content-->
    <div>
      <div *ngFor="let phone of this.phones; index as i"
        [ngModelGroup]="(phone.formId || i)">
        <nz-select class="select-phone-type" [(ngModel)]="phone.type" #ngPhoneType="ngModel"
          #phoneType
          name="phoneType" nzBorderless>
          <nz-option *ngFor="let type of phoneTypes" [nzValue]="type"
            [nzLabel]="type | getTranslateEnum:'phoneType'"></nz-option>
        </nz-select>
        <div class="d-flex" style="position: relative;" @fadeInAnimation>
          <div class="element">
            <!--  -->
            <input
              [required]="true"
              [ngStyle]="{'width': (phone.areaCode?.length + 1) + 'ch', 'min-width': '31px', 'max-width': '40px'}"
              [hidden]="!phonesCache[i]?.showArea"
              (blur)="onBlurInput(ngAreaCode, i, phone, 'areaCode',
              'areaCodePlaceholder', 'showArea', '---')"
              minlength="3"
              maxlength="3"
              (keyup)="this.helperValidationField.onValidateNumber(phone,
              'areaCode')"
              type="text"
              nz-input
              [(ngModel)]="phone.areaCode"
              #ngAreaCode="ngModel"
              #areaCode
              name="areaCode">
            <p *ngIf="!phonesCache[i]?.showArea"
              (click)="elementPhoneSelected('showArea', i, areaCode)">{{'(' +
              phone.areaCodePlaceholder + ')'}}</p>
          </div>
          <div class="element">
            <!--  -->
            <input
              [required]="true"
              [ngStyle]="{'min-width': '62px', 'max-width': '70px'}"
              [hidden]="!phonesCache[i]?.showNumber"
              (blur)="onBlurInput(ngPhoneNumber, i, phone, 'phoneNumber',
              'phoneNumberPlaceholder', 'showNumber', '-------')"
              minlength="7"
              maxlength="7"
              (keyup)="this.helperValidationField.onValidateNumber(phone,
              'phoneNumber')"
              type="text"
              nz-input
              [(ngModel)]="phone.phoneNumber"
              #ngPhoneNumber="ngModel"
              #phoneNumber
              name="phoneNumber">
            <p *ngIf="!phonesCache[i]?.showNumber"
              (click)="elementPhoneSelected('showNumber', i, phoneNumber)">{{
              phone.phoneNumberPlaceholder }}</p>
          </div>
          <div class="element ml-md">
            <span style="font-size: 12px; position: relative; top: 1px;">ext:</span>
          </div>
          <div class="element">
            <!-- -->
            <input
              [ngStyle]="{'width': (phone.ext?.length + 1) + 'ch', 'min-width': '37px', 'max-width': '40px'}"
              [hidden]="!phonesCache[i]?.showExt"
              (blur)="onBlurInput(ngExt, i, phone, 'ext', 'extPlaceholder',
              'showExt', '---')"
              minlength="0"
              maxlength="5"
              (keyup)="this.helperValidationField.onValidateNumber(phone,
              'ext')"
              type="text"
              nz-input
              [(ngModel)]="phone.ext"
              #ngExt="ngModel"
              #ext name="ext">
            <p *ngIf="!phonesCache[i]?.showExt" class="input-ext"
              [class.empty]="phone.ext.length === 0"
              (click)="elementPhoneSelected('showExt', i, ext)">{{
              phone.extPlaceholder }}</p>
          </div>
          <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar" class="delete icon-action danger" (click)="onDeletePhoneNumber(phone.formId)">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </div>
        </div>
        <p nz-typography [nzType]="'danger'" *ngIf="(ngAreaCode.control.touched
          && ngAreaCode.control.invalid) || (ngPhoneNumber.control.touched &&
          ngPhoneNumber.control.invalid) && !phone.isEqual" @fadeInAnimation style="font-size:
          0.7em;">
          Campo inválido
        </p>
        <p nz-typography [nzType]="'danger'" *ngIf="phone.isEqual" @fadeInAnimation style="font-size:
          0.7em;">
          Teléfono repetido
        </p>
        <nz-divider style="margin: 10px 0;" *ngIf="i <this.phones?.length - 1 &&
          !removeClassCardContainerShadow"></nz-divider>
      </div>
    </div>
  </div>
</form>


<!-- Templates -->
<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu nzSelectable>
    <li nz-menu-item>
      <i style="margin-right: 5px;" nz-icon nzType="eye" nzTheme="outline"></i>
      ver
    </li>
    <li nz-menu-item>
      <i style="margin-right: 5px;" nz-icon nzType="edit" nzTheme="outline"></i>
      modificar
    </li>
    <li nz-menu-divider></li>
    <li nz-menu-item nzDanger>
      <i style="margin-right: 5px;" nz-icon nzType="close" nzTheme="outline"></i>
      eliminar
    </li>
  </ul>
</nz-dropdown-menu>
<!-- / Templates -->
